import { render, staticRenderFns } from "./SingleShop.vue?vue&type=template&id=72030c6d&scoped=true&"
import script from "./SingleShop.vue?vue&type=script&lang=js&"
export * from "./SingleShop.vue?vue&type=script&lang=js&"
import style0 from "./SingleShop.vue?vue&type=style&index=0&id=72030c6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72030c6d",
  null
  
)

export default component.exports